export default "__VITE_ASSET__CextE_Ea__"